.SubNav__container {
  position: absolute;
  width: 100%;
  z-index: 2;
  border-block: var(--brand-borderWidth-thin) solid var(--brand-color-border-muted);
}

.SubNav__container--with-anchor-nav {
  display: unset;
  position: relative;
}

.SubNav__container--with-anchor-nav .SubNav {
  border-block: var(--brand-borderWidth-thin) solid var(--brand-color-border-muted);
}

.SubNav {
  width: 100%;
  display: flex;
  z-index: 1;
  background-color: var(--brand-SubNav-bgColor);
}

[data-color-mode='dark'] .SubNav {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.SubNav__heading,
.SubNav__subHeading {
  display: block;
  font-size: calc(var(--base-size-16) - 1px); /* One-off override to match design */
  line-height: calc(var(--base-size-16) - 1px); /* One-off override to match design */
  font-weight: var(--brand-text-subhead-weight-medium);
  color: var(--brand-color-text-default);
  font-family: var(--brand-heading-fontFamily);
  text-decoration: none;
}

.SubNav__heading:hover,
.SubNav__subHeading:hover,
.SubNav__link:hover .SubNav__link-label {
  color: var(--brand-color-text-muted);
  text-decoration: none !important; /* dotcom override */
}

.SubNav--header-container-outer {
  width: 100%;
}

.SubNav__heading-container {
  min-height: 60px;
  position: relative;
  z-index: 9998;
  display: flex;
  align-items: center;
  padding: var(--base-size-16);
  border-inline-end: var(--brand-borderWidth-thin) solid var(--brand-color-border-muted);
}

.SubNav__heading-container + .SubNav__heading-container {
  padding-inline-start: var(--base-size-24);
}

.SubNav--has-shadow {
  box-shadow: var(--brand-SubNav-shadow);
  background-color: var(--brand-color-canvas-default);
}

.SubNav--full-width {
  padding-inline: 0;
}

.SubNav__action-container {
  margin-left: auto;
}

.SubNav__sub-menu-icon {
  display: none !important;
}

.SubNav__sub-menu-children {
  display: contents;
}

.SubNav__links-overlay {
  list-style: none;
  margin: 0;
  padding: 0;
}

.SubNav__links-overlay > span {
  display: none;
}

.SubNav__sub-menu-toggle {
  display: none;
}

/*
   * Anchor Nav Submenu
   */

.SubNav__anchor-menu-outer-container {
  position: sticky;
  top: -1px;
  z-index: 91; /* must be higher than subdomain nav bar */
}

.SubNav__anchor-menu-container {
  opacity: 0;
  background-color: transparent;
  transform: translateY(var(--brand-animation-variant-slideInDown-distance));
  transition: opacity var(--brand-animation-duration-default) var(--brand-animation-easing-default),
    background-color var(--brand-animation-duration-default) var(--brand-animation-easing-default);
}

.SubNav__anchor-menu-outer-container:focus-within .SubNav__anchor-menu-container,
.SubNav__anchor-menu-outer-container--stuck .SubNav__anchor-menu-container {
  transform: translateY(0);
  opacity: 1;
  background-color: var(--brand-color-canvas-default);
}

.SubNav__anchor-menu-outer-container {
  height: 0;
  transition: height var(--brand-animation-duration-default) var(--brand-animation-easing-default);
}

.SubNav__anchor-menu-outer-container:focus-within,
.SubNav__anchor-menu-outer-container--stuck {
  height: auto;
}

.SubNav__sub-menu--anchor {
  opacity: 0;
  transform: translateY(var(--brand-animation-variant-slideInDown-distance));
  transition: opacity var(--brand-animation-duration-default) var(--brand-animation-easing-default),
    height var(--brand-animation-duration-default) var(--brand-animation-easing-default),
    transform var(--brand-animation-duration-default) var(--brand-animation-easing-default);
}

.SubNav__anchor-menu-outer-container:focus-within .SubNav__sub-menu--anchor,
.SubNav__anchor-menu-outer-container--stuck .SubNav__sub-menu--anchor {
  visibility: visible;
  opacity: 1;
  transform: translateY(0);
}

.SubNav__sub-menu--anchor {
  display: flex;
  padding-block: var(--base-size-12);
  border-block: var(--brand-borderWidth-thin) solid var(--brand-color-border-muted);
}

.SubNav__sub-menu--anchor .SubNav__sub-menu-list {
  display: inline-flex;
  list-style-type: none;
  margin: 0;
  padding: 0;
  gap: var(--base-size-20);
}

.SubNav__link-label {
  font-weight: 450; /* FIXME: unsupported in our font weight primitives */
}

.SubNav__sub-menu--anchor .SubNav__link-label {
  padding: var(--base-size-6) var(--base-size-12);
  background-color: transparent;
  border-radius: var(--brand-borderRadius-full);
  transition: background-color var(--brand-animation-duration-default) var(--brand-animation-easing-default),
    color var(--brand-animation-duration-default) var(--brand-animation-easing-default);
}

.SubNav__sub-menu--anchor .SubNav__link--is-in-view .SubNav__link-label {
  background-color: var(--brand-SubNav-color-link-bgColor);
}

.SubNav__link:focus-visible .SubNav__link-label::after,
.SubNav__sub-menu--anchor .SubNav__link--is-in-view:focus-visible .SubNav__link-label::after {
  opacity: 0;
}

.SubNav__link[aria-current]:not([aria-current='false']) * {
  color: var(--brand-SubNav-color-link-active);
  text-decoration: none !important; /* dotcom override */
}

.SubNav__link:hover .SubNav__link-label {
  transition: color var(--brand-animation-duration-fast) var(--brand-animation-easing-default);
}

.SubNav__link:hover .SubNav__link-label::after {
  border-color: var(--brand-color-text-default);
}

/*
 * Narrow breakpoint
 */

@media screen and (max-width: 63.24rem) {
  .SubNav {
    position: relative;
  }

  .SubNav::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    opacity: 0;
    z-index: 9997;
  }

  .SubNav::after {
    content: '';
    z-index: -1;
    position: fixed;
    background-color: var(--base-color-scale-black-0);
    opacity: 0;
    visibility: hidden;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
  }

  .SubNav--open::after {
    opacity: 0.3;
    visibility: visible;
    transition: visibility var(--brand-animation-duration-default) var(--brand-animation-easing-default),
      opacity var(--brand-animation-duration-default) var(--brand-animation-easing-default);
  }

  .SubNav__heading {
    font-size: var(--base-size-16);
    line-height: var(--base-size-24);
  }

  .SubNav--open {
    display: block;
  }

  .SubNav--open .SubNav--header-container-outer {
    display: flex;
    flex-direction: column;
    max-height: var(--subnav-available-height, 100dvh);
    overflow: hidden;
  }

  .SubNav--open .SubNav__header-container {
    flex-shrink: 0;
  }

  .SubNav--open + .SubNav__anchor-menu-outer-container {
    z-index: -1;
  }

  .SubNav--open::before {
    background-color: var(--brand-color-canvas-default);
    animation: fade-in 0.3s var(--brand-animation-easing-glide) forwards;
  }

  .SubNav__heading-separator--main:not(.SubNav__heading-separator--has-adjacent-label),
  .SubNav__heading-separator--subheading-active,
  .SubNav__subheading-container-active {
    display: none;
  }

  .SubNav__header-container {
    display: flex;
    width: 100%;
    white-space: pre;
    position: relative;
    z-index: 9998;
  }

  .SubNav__heading-container + .SubNav__heading-container {
    padding-inline-start: var(--base-size-16);
  }

  .SubNav__heading-separator {
    margin-inline-end: var(--base-size-16);
    z-index: 9998;
  }

  .SubNav__links-overlay {
    position: relative;
    display: flex;
    flex: auto;
    flex-direction: column;
    justify-content: center;
    z-index: 9998;
    display: none;
    padding-inline: var(--base-size-8);
  }

  .SubNav__links-overlay--open {
    display: flex;
    flex-direction: column;
    gap: var(--base-size-8);
    padding-block: var(--base-size-16);
    border-block-start: var(--brand-borderWidth-thin) solid var(--brand-color-border-muted);
    justify-content: flex-start;
    overflow-y: auto;
    min-height: 0;
  }

  .SubNav__links-overlay--open .SubNav__link:hover .SubNav__link-label {
    color: var(--brand-color-text-default);
  }

  .SubNav__overlay-toggle {
    display: flex;
    position: relative;
    width: 100%;
    z-index: 9999;
    justify-content: flex-end;
    padding-inline-end: var(--base-size-16);
  }

  .SubNav--has-sub-heading:not(.SubNav--subHeadingActive) .SubNav__overlay-toggle {
    border-block-start: var(--brand-borderWidth-thin) solid var(--brand-color-border-muted);
    display: block;
    padding-block: var(--base-size-12);
    margin-block: 0;
  }

  .SubNav__overlay-toggle-content {
    width: 100%;
    padding-inline-start: var(--base-size-16);
  }

  .SubNav__overlay-toggle-label {
    background-color: var(--brand-SubNav-color-link-bgColor);
    border: none;
    border-radius: var(--brand-borderRadius-full);
    padding: var(--base-size-4) var(--base-size-12);
    gap: var(--base-size-6);
    display: flex;
    align-items: center;
    cursor: pointer;
    font: inherit;
  }

  .SubNav--full-width .SubNav__overlay-toggle {
    right: 0;
  }

  .SubNav__link,
  .SubNav__action-container {
    display: none;
    text-decoration: none;
  }

  .SubNav__links-overlay--open .SubNav__link-label {
    position: relative;
  }

  .SubNav__links-overlay--open .SubNav__link[aria-current]:not([aria-current='false']) * {
    color: var(--brand-SubNav-color-link-active);
  }

  .SubNav__links-overlay--open .SubNav__link {
    margin-inline-start: var(--base-size-8);
    padding: var(--base-size-4) var(--base-size-12);
  }

  .SubNav__links-overlay--open .SubNav__link[aria-current]:not([aria-current='false']) {
    display: inline-flex;
    background-color: var(--brand-SubNav-color-link-bgColor);
    border-radius: var(--brand-borderRadius-full);
  }

  .SubNav__links-overlay--open .SubNav__link:hover {
    display: inline-flex;
    background-color: var(--brand-SubNav-color-link-bgColor);
    border-radius: var(--brand-borderRadius-full);
  }

  .SubNav__links-overlay--open .SubNav__link {
    display: inline-flex;
    animation: fade-in 0.3s var(--brand-animation-easing-glide) forwards;
  }

  .SubNav__links-overlay--open .SubNav__action-container {
    display: block;
    animation: fade-in 0.3s var(--brand-animation-easing-glide) forwards;
  }

  .SubNav__links-overlay--open .SubNav__link--has-sub-menu {
    padding-block: 0;
  }

  .SubNav__links-overlay--open .SubNav__action-container {
    width: 100%;
  }

  .SubNav__links-overlay--open .SubNav__action {
    width: 100%;
  }

  .SubNav__sub-menu {
    list-style: none;
    padding: 0;
    margin: 0;
    padding-inline-start: var(--base-size-16);
    padding-block-start: var(--base-size-8);
    display: flex;
    flex-direction: column;
    gap: var(--base-size-8);
  }

  .SubNav__sub-menu .SubNav__link {
    margin-inline-start: 0;
  }

  .SubNav__sub-menu--dropdown .SubNav__link:hover .SubNav__link-label {
    color: var(--brand-color-text-default) !important;
  }

  .SubNav__anchor-menu-container {
    z-index: 99;
    overflow-x: auto;
    overflow-y: hidden;
    width: 100%;
  }

  .SubNav__anchor-menu-outer-container {
    position: sticky;
    top: -1px;
  }

  .SubNav__anchor-menu-outer-container::after {
    content: '';
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: var(--base-size-32);
    background: linear-gradient(to left, var(--brand-color-canvas-default), transparent);
    pointer-events: none;
    z-index: 100;
  }

  .SubNav__sub-menu--anchor {
    padding-inline: var(--base-size-16);
    padding-block-end: var(--base-size-16);
    padding-block-start: var(--base-size-16);
  }

  .SubNav__sub-menu--anchor .SubNav__link-label {
    font-size: var(--brand-text-size-100);
    line-height: var(--brand-text-lineHeight-100);
    letter-spacing: var(--brand-text-letterSpacing-100);
  }

  .SubNav__sub-menu--anchor .SubNav__sub-menu-list {
    padding-inline-end: var(--base-size-32);
  }

  .SubNav__sub-menu--anchor .SubNav__link {
    display: block;
    white-space: pre;
    position: relative;
    top: var(--base-size-2);
  }
}

.SubNav__overlay-toggle-icon {
  fill: var(--brand-color-text-default);
}

.SubNav__overlay-toggle-content {
  display: flex;
  align-items: center;
  gap: var(--base-size-8);
}

.SubNav__overlay-toggle-content--end {
  justify-content: flex-end;
}

.SubNav__link:focus-visible,
.SubNav__heading:focus-visible,
.SubNav__subHeading:focus-visible,
.SubNav__sub-menu-toggle:focus-visible,
.SubNav__overlay-toggle-label:focus-visible {
  outline: var(--brand-borderWidth-thick) solid var(--brand-color-focus);
  outline-offset: var(--base-size-2);
}

.SubNav__subHeading {
  display: block;
  position: relative;
  white-space: nowrap;
}

.SubNav__subHeading[aria-current]:not([aria-current='false']) {
  background-color: var(--brand-SubNav-color-link-bgColor);
  border: none;
  border-radius: var(--brand-borderRadius-full);
  padding: var(--base-size-6) var(--base-size-12);
}

@media screen and (min-width: 48rem) {
  .SubNav__heading-container {
    padding-inline: var(--base-size-24);
  }

  .SubNav__overlay-toggle-content {
    padding-inline-start: var(--base-size-24);
  }

  .SubNav__links-overlay--open {
    padding: var(--base-size-24);
  }

  .SubNav--full-width {
    padding-inline: 0;
  }

  .SubNav__sub-menu--anchor {
    padding-inline: var(--base-size-24);
  }
}

.SubNav__heading-label {
  white-space: pre;
}

/*
 * Wide breakpoint
 */

@media screen and (min-width: 63.25rem) {
  .SubNav {
    align-items: center;
    display: flex;
    z-index: 92;
    padding-inline: var(--base-size-32);
  }

  .SubNav__links-overlay--open {
    padding: 0;
  }

  .SubNav:has(+ .SubNav__anchor-menu-container) {
    padding-block-end: 0;
  }

  .SubNav__heading-container {
    padding-inline-start: 0;
  }

  .SubNav--full-width {
    padding-inline: 0;
  }

  .SubNav__overlay-toggle {
    display: none;
  }

  .SubNav__container--with-anchor-nav .SubNav__heading {
    padding-block-end: 1px;
  }

  .SubNav__heading-separator {
    margin-inline-end: var(--base-size-20);
    display: inline-flex;
    top: 0;
  }

  .SubNav__container--with-anchor-nav .SubNav__heading-separator {
    top: -1px;
  }

  .SubNav--header-container-outer {
    display: flex;
    align-items: center;
  }

  .SubNav__header-container {
    display: flex;
    align-items: center;
  }

  .SubNav__links-overlay {
    align-items: center;
    display: flex;
    gap: var(--base-size-2);
    z-index: 92;
    flex-grow: 1;
    padding-inline-start: var(--base-size-24);
  }

  .SubNav__link {
    text-decoration: none !important; /* dotcom override */
    transition: color 0.2s var(--brand-animation-easing-glide);
    position: relative;
    padding: var(--base-size-4) var(--base-size-12);
    border-radius: var(--brand-borderRadius-full);
  }

  .SubNav__link-label {
    font-size: var(--brand-text-size-100);
    line-height: var(--brand-text-lineHeight-100);
  }

  .SubNav__link--has-sub-menu {
    padding: var(--base-size-4) 0;
  }

  /* To fix hover distance between link and dropdown */
  .SubNav__link--has-sub-menu::after {
    content: '';
    position: absolute;
    bottom: calc(var(--base-size-12) * -1);
    left: 0;
    width: 100%;
    height: var(--base-size-12);
    background: transparent;
  }

  .SubNav__sub-menu.SubNav__sub-menu--dropdown {
    background-clip: padding-box;
    background-color: var(--brand-color-canvas-default);
    border: var(--brand-color-border-muted) solid var(--brand-borderWidth-thin);
    border-radius: var(--brand-borderRadius-medium);
    left: 0;
    list-style: none;
    margin-block-start: var(--base-size-8);
    padding: var(--base-size-8);
    position: absolute;
    top: 90%;
    z-index: 9998;
    transition-timing-function: var(--brand-animation-easing-glide);
    transition-duration: var(--brand-animation-duration-fast);
    transition-property: opacity, transform;
    left: var(--base-size-4);
    visibility: hidden;
    opacity: 0;
    transform: scale(0.99) translateY(-0.7em) translateX(-8px);
    transform-origin: top;
    display: flex;
    flex-direction: column;
    gap: var(--base-size-8);
    width: var(--brand-SubNav-width-subMenu);
  }

  .SubNav__link--expanded .SubNav__sub-menu.SubNav__sub-menu--dropdown {
    visibility: visible;
    opacity: 1;
    transform: scale(1) translateY(0) translateX(-8px);
  }

  .SubNav__sub-menu-toggle {
    width: var(--base-size-24);
    height: var(--base-size-24);
    border: none;
    padding: 0;
    margin: 0;
    padding-inline-end: var(--base-size-8);
    margin-inline-end: calc(-1 * var(--base-size-8));
    background: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .SubNav__sub-menu .SubNav__link {
    display: block;
  }

  .SubNav__sub-menu--dropdown .SubNav__link-label::after {
    opacity: 1;
    transform: scale(0);
  }

  .SubNav__link--has-sub-menu {
    position: relative;
    display: inline-flex;
    align-items: center;
    gap: var(--base-size-4);
    cursor: pointer;
  }

  .SubNav__link--has-sub-menu > .SubNav__link {
    padding-inline-end: 0;
  }

  .SubNav__sub-menu--dropdown .SubNav__link-label {
    position: relative;
    padding: var(--base-size-4) 0;
  }

  /* Show pill on submenu parent */
  .SubNav__link--has-active-sub-menu {
    background-color: var(--brand-SubNav-color-link-bgColor);
    border-radius: var(--brand-borderRadius-full);
    padding: 0 var(--base-size-8) 0 0;
    gap: 0;
  }

  .SubNav__link--has-active-sub-menu > .SubNav__link {
    padding: var(--base-size-4) 0 var(--base-size-4) var(--base-size-12);
  }

  .SubNav__sub-menu.SubNav__sub-menu--dropdown .SubNav__link {
    padding: var(--base-size-12);
  }

  /* Active link pill styling */
  .SubNav__links-overlay .SubNav__link[aria-current]:not([aria-current='false']) {
    background-color: var(--brand-SubNav-color-link-bgColor);
    line-height: 1.1em;
  }

  /* Firefox optical alignment fix */
  @supports (-moz-appearance: none) {
    .SubNav__links-overlay
      .SubNav__link--has-sub-menu
      .SubNav__link[aria-current]:not([aria-current='false'])
      .SubNav__link-label {
      top: 0;
    }
  }

  .SubNav__links-overlay .SubNav__link--has-active-sub-menu .SubNav__link[aria-current]:not([aria-current='false']) {
    padding-inline-end: var(--base-size-4);
  }

  .SubNav__sub-menu.SubNav__sub-menu--dropdown .SubNav__link[aria-current]:not([aria-current='false']) {
    background-color: transparent;
    border-radius: var(--brand-borderRadius-medium);
    padding: var(--base-size-4) var(--base-size-8) var(--base-size-4) var(--base-size-12);
    top: unset;
  }

  .SubNav__sub-menu.SubNav__sub-menu--dropdown .SubNav__link:hover {
    background-color: var(--brand-SubNav-color-link-bgColor);
    border-radius: var(--brand-borderRadius-medium);
  }

  .SubNav__sub-menu-icon {
    display: inline-block !important;
    fill: var(--brand-color-text-muted);
    transition: transform var(--brand-animation-duration-fast);
  }

  .SubNav__link--has-sub-menu:not(.SubNav__link--has-active-sub-menu) .SubNav__sub-menu-icon {
    position: relative;
    top: calc(-1 * var(--brand-borderWidth-thin));
  }

  .SubNav__sub-menu--anchor {
    padding-inline: var(--base-size-32);
  }
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes fade-in-down {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

/* Remove all animations, transitions and smooth scroll for people that prefer not to see them */
@media (prefers-reduced-motion: reduce) {
  .SubNav,
  .SubNav::before,
  .SubNav::after,
  .SubNav * {
    animation: none !important;
    transition: none !important;
    scroll-behavior: auto !important;
  }
}
